/**
 * The two canvas colours, as literals: `--bg` in `globals.css` (`:root` and the
 * dark block). The browser chrome (the `theme-color` meta, the address-bar
 * tint) and the web app manifest cannot read a CSS var, so this module is the
 * one place their values live - the boot script in `layout.tsx`, `useTheme`
 * (`use-theme.ts`) and `manifest.ts` all import it. It is the sanctioned
 * colour literal of `.claude/rules/ui-kit.md`. Change it together with `--bg`.
 *
 * No `'use client'`: the server layout, the manifest route and the client hook
 * share it.
 */
export const THEME_CANVAS = { light: '#f3f2ef', dark: '#1b1813' } as const;
